export default function preferencesReducer(state = false, action) {
  switch (action.type) {
    case 'SET_SIZE':
      return action.payload
    default:
      return state
  }
}
